var _defs, _g, _path, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "2cda36280c"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "83fe103f44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.917969 0 L 28.046875 0 L 28.046875 29.03125 L 1.917969 29.03125 Z M 1.917969 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c3494fca1b"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#2cda36280c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb2274ecc3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.269531 0.179688 L 23.730469 0.179688 L 23.730469 6.21875 L 0.269531 6.21875 Z M 0.269531 0.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c3417252ff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 24,
    y: 0,
    height: 7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#83fe103f44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de3163",
    d: "M 25.160156 2.902344 L 23.707031 2.902344 L 23.707031 0 L 20.804688 0 L 20.804688 2.902344 L 9.191406 2.902344 L 9.191406 0 L 6.289062 0 L 6.289062 2.902344 L 4.835938 2.902344 C 3.238281 2.902344 1.933594 4.207031 1.933594 5.804688 L 1.933594 26.128906 C 1.933594 27.730469 3.238281 29.03125 4.835938 29.03125 L 25.160156 29.03125 C 26.761719 29.03125 28.0625 27.730469 28.0625 26.128906 L 28.0625 5.804688 C 28.0625 4.207031 26.761719 2.902344 25.160156 2.902344 Z M 25.160156 5.804688 L 25.160156 8.710938 L 4.835938 8.710938 L 4.835938 5.804688 Z M 4.835938 26.128906 L 4.835938 11.613281 L 25.160156 11.613281 L 25.160156 26.128906 Z M 4.835938 26.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#de3163",
    d: "M 10.644531 17.417969 L 19.355469 17.417969 L 19.355469 20.324219 L 10.644531 20.324219 Z M 10.644531 17.417969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#de3163",
    d: "M 13.546875 23.226562 L 13.546875 14.515625 L 16.449219 14.515625 L 16.449219 23.226562 Z M 13.546875 23.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c3494fca1b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3, 4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c3417252ff)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb2274ecc3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de3163",
    d: "M 0.386719 0.355469 L 23.613281 0.355469 L 23.613281 6.160156 L 0.386719 6.160156 Z M 0.386719 0.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPlus);
export default __webpack_public_path__ + "static/media/calendarPlus.58ed35d37711178f673591165e2c3ae4.svg";
export { ForwardRef as ReactComponent };